import { ButtonT10, ButtonT2 } from "Components/Common/Button/index";
import { TypographyT60 } from "Components/Common/Typography/index";
import { FlexWrapperT13 } from "Components/Common/Wrapper/FlexWrapper";
import TooltipT1 from "Components/Common/ToolTip/TooltipT1";
import { isDesmetSupplier } from "Utils/index";
import React, { Fragment } from "react";

const HeaderSection = (props) => {
  const { title, handleOnClickForCreateRequestBtn, handleDownloadMaterialDescriptions, isDateRangeSelected } = props;
  return (
    <Fragment>
      <FlexWrapperT13>
        <TypographyT60>{title}</TypographyT60>
        <FlexWrapperT13>
          <TooltipT1>
            <ButtonT2
              onClick={isDateRangeSelected ? handleDownloadMaterialDescriptions : undefined}
              disabled={!isDateRangeSelected}
            >
              Download Material Descriptions
            </ButtonT2>
            {!isDateRangeSelected && (
              <span style={{
                background: "#101828",
                color: "#fff",
                borderRadius: "4px",
                padding: "4px 10px",
                fontSize: "12px",
                whiteSpace: "nowrap",
              }}>
                Select date range to download the material description
              </span>
            )}
          </TooltipT1>
          {isDesmetSupplier() && (
            <ButtonT10 onClick={handleOnClickForCreateRequestBtn}>
              Create Request
            </ButtonT10>
          )}
        </FlexWrapperT13>
      </FlexWrapperT13>
    </Fragment>
  );
};

export default HeaderSection;
